
interface QuickActionsProps {
  onAction?: (action: string) => void;
}

const actions = [
  { id: 1, label: 'Nueva Operación', icon: 'ri-add-circle-line', color: 'from-[#114B7A] to-[#2F80ED]' },
  { id: 2, label: 'Registrar Cliente', icon: 'ri-user-add-line', color: 'from-[#10B981] to-[#059669]' },
  { id: 3, label: 'Generar Factura', icon: 'ri-file-text-line', color: 'from-[#EAB308] to-[#CA8A04]' },
  { id: 4, label: 'Ver Reportes', icon: 'ri-bar-chart-box-line', color: 'from-[#2F80ED] to-[#1D4ED8]' },
];

export default function QuickActions({ onAction }: QuickActionsProps) {
  return (
    <div className="bg-white rounded-lg p-6 border border-gray-200">
      <h3 className="text-lg font-bold text-[#0A2A43] mb-4">Accesos Rápidos</h3>
      
      <div className="space-y-3">
        {actions.map((action) => (
          <button
            key={action.id}
            onClick={() => onAction?.(action.label)}
            className={`w-full flex items-center gap-3 p-4 rounded-lg bg-gradient-to-r ${action.color} text-white hover:shadow-md transition-all cursor-pointer whitespace-nowrap`}
          >
            <div className="w-10 h-10 rounded-lg bg-white/20 flex items-center justify-center">
              <i className={`${action.icon} text-xl`}></i>
            </div>
            <span className="text-sm font-semibold">{action.label}</span>
            <i className="ri-arrow-right-line ml-auto"></i>
          </button>
        ))}
      </div>
    </div>
  );
}
